import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './cookie-policy.component.html',
})
export class CookiePolicyComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
